/**
 * @file
 * Tablesaw Init
 */

(function ($, Drupal) {
  Drupal.behaviors.tablesawInit = {
    attach: function (context, settings) {
      "use strict";

      $('body', context).trigger("enhance.tablesaw");

      // init tooltip for table based on title attr
      var $tooltipConfig = {
        content: {
          title: 'Description',
          // text: $(this).attr('title'), // default value
        },
        position: {
          //   my: 'top center',  // Position my top left...
          //   at: 'bottom center', // at the bottom right of...
          target: 'mouse',
          adjust: {
            // mouse: false,  ...but don't follow the mouse
            y: 15
          }
        },
        show: {
          solo: true,
          delay: 500
        },
        hide: {
         distance: 10
        },
        style: {
          classes: 'qtip-blue qtip-shadow etbu-qtip',
          def: false // Remove the default styling (usually a good idea, see below)
        }
      }

      // init table cell tooltip
      $('.tablefield .table__heading-cell[title!=""]').qtip($tooltipConfig);
      $('.table__row .table__cell[title!=""]').qtip($tooltipConfig);
    }
  };
})(jQuery, Drupal);
